import { Component, OnInit, inject } from '@angular/core';

import { Announcement } from '../announcement';
import { AnnouncementService } from '../announcement.service';

@Component({
  selector: 'app-announcement',
  templateUrl: './announcement.component.html',
  styleUrls: ['./announcement.component.scss'],
  standalone: false
})
export class AnnouncementComponent implements OnInit {
  private announcementService = inject(AnnouncementService);

  announcement: Announcement | null = null;
  show = true;

  ngOnInit() {
    this.getAnnouncement();
  }

  close(): void {
    this.show = false;
  }

  private getAnnouncement(): void {
    this.announcementService.getAnnouncement().subscribe((announcement) => {
      this.announcement = announcement;
    });
  }
}
